import Helper from "./Helper";
import Swiper from "swiper/bundle";

class HighlightSlider {
  constructor(config = {}) {
    const {
      outerWrapperSelector,
      sliderContainerSelector,
      sliderPaginationselector,
      sliderPrevSelector,
      sliderNextSelector,
      sliderBreakpoint,
    } = config;
    this.outerWrapperSelector = outerWrapperSelector;
    this.sliderContainerSelector =
      sliderContainerSelector || ".swiper-container";
    this.sliderPaginationselector =
      sliderPaginationselector || ".swiper-pagination";
    this.sliderPrevSelector = sliderPrevSelector || ".swiper-button-prev";
    this.sliderNextSelector = sliderNextSelector || ".swiper-button-next";
    this.sliderBreakpoint = sliderBreakpoint || 768;
    this.sliderBreakpointTablet = 1170;
    this.body = document.querySelector("body");

    this.sliders = document.querySelectorAll(this.outerWrapperSelector);
    this.slidersArray = Array.prototype.slice.call(this.sliders);
    this.swiperContainer = document.querySelector('.swiper-wrapper');

    this.currentScreenWidth = window.innerWidth;
    this.previousScreenWidth = window.innerWidth;
    this.sliderIsInitiated = false;
    this.currentlyMobile = "";
    this.currentlyTablet = "";
    this.currentlyDesktop = "";
    this.swiperInstances = [];
    if (this.sliders && this.sliders.length > 0) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.showOverlay(this.currentScreenWidth);

    if (this.currentScreenWidth < this.sliderBreakpoint) {
      this.currentlyMobile = true;
      this.currentlyDesktop = false;
      this.currentlyTablet = false;
      this.initSwipersMobile();
    } else if(this.currentScreenWidth < this.sliderBreakpointTablet) {
      this.currentlyMobile = false;
      this.currentlyDesktop = false;
      this.currentlyTablet = true;
      this.initSwipersTablet();
    } else {
      this.currentlyMobile = false;
      this.currentlyDesktop = true;
      this.currentlyTablet = false;
      this.initSwipersDesktop();
    }

    window.addEventListener("resize", () => {
      const vw = window.innerWidth;
      //location.reload(); //ugly hack as hell. But otherwise it seems to be wrong

      if (this.previousScreenWidth < this.sliderBreakpoint) {
        if (vw > this.sliderBreakpoint) {
          this.currentlyMobile = false;
          this.currentlyDesktop = true;
          this.currentlyTablet = false;
          this.destroySwipers();
          this.initSwipersDesktop();

          this.allOverlays = document.querySelectorAll('.ns-highlights__item:not(.ns-highlights__item--link)');

          console.log(this.allOverlays);
          Helper.removeClass(this.body, "slider-active");
          Helper.removeClass(this.swiperContainer, 'active');
        }
      }

      if (this.previousScreenWidth < this.sliderBreakpointTablet) {
        if (vw > this.sliderBreakpointTablet) {
          this.currentlyMobile = false;
          this.currentlyDesktop = false;
          this.currentlyTablet = true;
          this.destroySwipers();
          this.initSwipersTablet();
        }
      }

      if (this.previousScreenWidth > this.sliderBreakpoint) {
        if (vw < this.sliderBreakpoint) {
          this.currentlyMobile = true;
          this.currentlyDesktop = false;
          this.currentlyTablet = false;
          this.destroySwipers();
          this.initSwipersMobile();
        }
      }

      Helper.removeClass(this.body, "slider-active");
      Helper.removeClass(this.swiperContainer, 'active');
      this.overlays.forEach(overlay => {
        Helper.removeClass(overlay, 'active-slide');
      });
      this.showOverlay(vw);
      this.previousScreenWidth = vw;
    });
  }

  showOverlay(viewpointWidth) {
    this.allOverlays = document.querySelectorAll('.ns-highlights__item:not(.ns-highlights__item--link):not(.ns-highlights__item--video)');
    this.overlays = Array.prototype.slice.call(this.allOverlays);

    this.overlays.forEach(overlay => {
      if (viewpointWidth < 1024) {
        overlay.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();

          Helper.addClass(this.body, "slider-active");
          let overlayContent = overlay.getElementsByClassName('ns-highlights__content');
          console.log(overlayContent);
          let clonedContent = overlayContent[0].cloneNode(true);
          clonedContent.classList.add('cloned');

          let closeButton = clonedContent.childNodes[0];
          closeButton.addEventListener('click', e => {
            const itemToClose = Helper.getClosest(closeButton, '.ns-highlights__content.cloned');
            e.preventDefault();
            e.stopPropagation();
            itemToClose.remove();
            Helper.removeClass(this.body, "slider-active");
          });

          this.body.appendChild(clonedContent);
        });
      }
    });
  }

  initSwipersDesktop() {
    this.slidersArray.forEach((slider, index) => {
      const swiperContainer = slider.querySelector(
        this.sliderContainerSelector
      );
      let swiperConfig = {
        slidesPerView: 'auto',
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        initialSlide: -1,
        watchOverflow: true,
        spaceBetween: 30,
        centeredSlides: true,
        normalizeSlideIndex: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        lazy: {
          loadOnTransitionStart: true,
          elementClass: 'lazy',
          loadedClass: 'loaded'
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
          formatFractionTotal: function(number){
            return (number);
          },
          renderFraction: function (currentClass, totalClass) {
            return (
              '<span class="' +
              currentClass +
              '"></span>' +
              ' <span class="fraction-line"></span> ' +
              '<span class="' +
              totalClass +
              '"></span>'
            );
          },
        }
      };
      const instance = new Swiper(swiperContainer, swiperConfig);
      this.swiperInstances.push(instance);
    });
  }

  initSwipersTablet() {
    this.slidersArray.forEach((slider, index) => {
      const swiperContainer = slider.querySelector(
        this.sliderContainerSelector
      );
      let swiperConfig = {
        slidesPerView: 'auto',
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        initialSlide: 0,
        watchOverflow: true,
        spaceBetween: 30,
        centeredSlides: false,
        normalizeSlideIndex: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        lazy: {
          loadOnTransitionStart: true,
          elementClass: 'lazy',
          loadedClass: 'loaded'
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
          formatFractionTotal: function(number){
            return (number);
          },
          renderFraction: function (currentClass, totalClass) {
            return (
              '<span class="' +
              currentClass +
              '"></span>' +
              ' <span class="fraction-line"></span> ' +
              '<span class="' +
              totalClass +
              '"></span>'
            );
          },
        }
      };
      const instance = new Swiper(swiperContainer, swiperConfig);
      this.swiperInstances.push(instance);
    });
  }

  initSwipersMobile() {
    this.slidersArray.forEach((slider, index) => {
      const swiperContainer = slider.querySelector(
        this.sliderContainerSelector
      );
      let swiperConfig = {
        slidesPerView: 'auto',
        slidesPerColumn: 1,
        slidesPerGroup: 1,
        initialSlide: 0,
        spaceBetween: 0,
        centeredSlides: true,
        normalizeSlideIndex: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        lazy: {
          loadOnTransitionStart: true,
          elementClass: 'lazy',
          loadedClass: 'loaded'
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
          renderFraction: function (currentClass, totalClass) {
            return (
              '<span class="' +
              currentClass +
              '"></span>' +
              ' <span class="fraction-line"></span> ' +
              '<span class="' +
              totalClass +
              '"></span>'
            );
          },
          clickable: true,
          // dynamicBullets: true,
        },
      };
      const instance = new Swiper(swiperContainer, swiperConfig);
      this.swiperInstances.push(instance);
    });
  }

  destroySwipers() {
    this.swiperInstances.forEach((instance) => {
      instance.destroy(true, true);
    });
  }
}

export default HighlightSlider;
